import { IpaginatedToppagesjoinus, IToppagesjoinusItem } from '../models'

export enum ToppagesjoinusActionTypes {
  SEARCH_TOPPAGESJOINUS = 'toppagesjoinus/search',
  SEARCHING_TOPPAGESJOINUS = 'toppagesjoinus/searching',
  FOUND_TOPPAGESJOINUS = 'toppagesjoinus/found',
  SEARCHING_TOPPAGESJOINUS_FAILED = 'toppagesjoinus/searching_failed',

  LOAD_TOPPAGESJOINUS = 'toppagesjoinus/load',
  LOADING_TOPPAGESJOINUS = 'toppagesjoinus/loading',
  LOADED_TOPPAGESJOINUS = 'toppagesjoinus/loaded',
  LOADING_TOPPAGESJOINUS_FAILED = 'toppagesjoinus/loading_failed',

  ADD_TOPPAGESJOINUS = 'toppagesjoinus/add',
  ADDING_TOPPAGESJOINUS = 'toppagesjoinus/adding',
  ADDED_TOPPAGESJOINUS = 'toppagesjoinus/added',
  ADDING_TOPPAGESJOINUS_FAILED = 'toppagesjoinus/adding_failed',

  REMOVE_TOPPAGEJOINUS = 'toppagesjoinus/remove',
  REMOVING_TOPPAGEJOINUS = 'toppagesjoinus/removing',
  REMOVED_TOPPAGEJOINUS = 'toppagesjoinus/removed',
  REMOVING_TOPPAGEJOINUS_FAILED = 'toppagesjoinus/removing_failed',

  SOFT_REMOVE_TOPPAGESJOINUS = 'toppagesjoinus/soft_remove',
  SOFT_REMOVING_TOPPAGESJOINUS = 'toppagesjoinus/soft_removing',
  SOFT_REMOVED_TOPPAGESJOINUS = 'toppagesjoinus/soft_removed',
  SOFT_REMOVING_TOPPAGESJOINUS_FAILED = 'toppagesjoinus/soft_removing_failed',

  EDIT_TOPPAGESJOINUS = 'toppagesjoinus/edit',
  EDITING_TOPPAGESJOINUS = 'toppagesjoinus/editing',
  EDITED_TOPPAGESJOINUS = 'toppagesjoinus/edited',
  EDITING_TOPPAGESJOINUS_FAILED = 'toppagesjoinus/editing_failed',

  VIEW_TOPPAGESJOINUS = 'toppagesjoinus/view',
  VIEWING_TOPPAGESJOINUS = 'toppagesjoinus/viewing',
  VIEWED_TOPPAGESJOINUS = 'toppagesjoinus/viewed',
  VIEWING_TOPPAGESJOINUS_FAILED = 'toppagesjoinus/viewing_failed',
}

export function searchToppagesjoinus(searchOptions: TSearchOptions | string, keep?: boolean): ISearchToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.SEARCH_TOPPAGESJOINUS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingToppagesjoinus(): ISearchingToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.SEARCHING_TOPPAGESJOINUS,
  }
}

export function foundToppagesjoinus(toppagesjoinus: IpaginatedToppagesjoinus, keep?: boolean): IFoundToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.FOUND_TOPPAGESJOINUS,
    keep: keep,
    payload: {
      toppagesjoinus,
    },
  }
}

export function searchingToppagesjoinusFailed(): ISearchingToppagesjoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.SEARCHING_TOPPAGESJOINUS_FAILED,
  }
}

export function loadToppagesjoinus(loadOptions: TSearchOptions): ILoadToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.LOAD_TOPPAGESJOINUS,
    loadOptions: loadOptions,
  }
}

export function loadingToppagesjoinus(): ILoadingToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.LOADING_TOPPAGESJOINUS,
  }
}

export function loadedToppagesjoinus(toppagesjoinus: IpaginatedToppagesjoinus): ILoadedToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.LOADED_TOPPAGESJOINUS,
    payload: {
      toppagesjoinus,
    },
  }
}

export function loadingToppagesjoinusFailed(): ILoadingToppagesjoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.LOADING_TOPPAGESJOINUS_FAILED,
  }
}

export function addToppagesjoinus(toppagejoinus: IToppagesjoinusItem): IAddToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.ADD_TOPPAGESJOINUS,
    payload: toppagejoinus,
  }
}

export function addingToppagesjoinus(): IAddingToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.ADDING_TOPPAGESJOINUS,
  }
}

export function addedToppagesjoinus(toppagesjoinus: IpaginatedToppagesjoinus): IAddedToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.ADDED_TOPPAGESJOINUS,
    payload: {
      toppagesjoinus,
    },
  }
}

export function addingToppagesjoinusFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingToppagesjoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.ADDING_TOPPAGESJOINUS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeToppagejoinus(toppagejoinus: IToppagesjoinusItem): IRemoveToppagejoinusAction {
  return {
    type: ToppagesjoinusActionTypes.REMOVE_TOPPAGEJOINUS,
    payload: toppagejoinus,
  }
}

export function removingToppagejoinus(): IRemovingToppagejoinusAction {
  return {
    type: ToppagesjoinusActionTypes.REMOVING_TOPPAGEJOINUS,
  }
}

export function removedToppagejoinus(): IRemovedToppagejoinusAction {
  return {
    type: ToppagesjoinusActionTypes.REMOVED_TOPPAGEJOINUS,
  }
}

export function removingToppagejoinusFailed(): IRemovingToppagejoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.REMOVING_TOPPAGEJOINUS_FAILED,
  }
}

export function softRemoveToppagesjoinus(toppagejoinus: IToppagesjoinusItem): ISoftRemoveToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.SOFT_REMOVE_TOPPAGESJOINUS,
    payload: toppagejoinus,
  }
}

export function softRemovingToppagesjoinus(): ISoftRemovingToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.SOFT_REMOVING_TOPPAGESJOINUS,
  }
}

export function softRemovedToppagesjoinus(toppagejoinus: IToppagesjoinusItem): ISoftRemovedToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.SOFT_REMOVED_TOPPAGESJOINUS,
    payload: toppagejoinus,
  }
}

export function softRemovingToppagesjoinusFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingToppagesjoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.SOFT_REMOVING_TOPPAGESJOINUS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editToppagesjoinus(toppagejoinus: IToppagesjoinusItem): IEditToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.EDIT_TOPPAGESJOINUS,
    payload: toppagejoinus,
  }
}

export function editingToppagesjoinus(): IEditingToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.EDITING_TOPPAGESJOINUS,
  }
}

export function editedToppagesjoinus(toppagesjoinus: IToppagesjoinusItem): IEditedToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.EDITED_TOPPAGESJOINUS,
    payload: toppagesjoinus,
  }
}

export function editingToppagesjoinusFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingToppagesjoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.EDITING_TOPPAGESJOINUS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewToppagesjoinus(toppagejoinus: IToppagesjoinusItem): IViewToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.VIEW_TOPPAGESJOINUS,
    payload: toppagejoinus,
  }
}

export function viewingToppagesjoinus(): IViewingToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.VIEWING_TOPPAGESJOINUS,
  }
}

export function viewedToppagesjoinus(toppagesjoinus: IToppagesjoinusItem): IViewedToppagesjoinusAction {
  return {
    type: ToppagesjoinusActionTypes.VIEWED_TOPPAGESJOINUS,
    payload: toppagesjoinus,
  }
}

export function viewingToppagesjoinusFailed(): IViewingToppagesjoinusFailedAction {
  return {
    type: ToppagesjoinusActionTypes.VIEWING_TOPPAGESJOINUS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.SEARCH_TOPPAGESJOINUS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.SEARCHING_TOPPAGESJOINUS
}

export interface IFoundToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.FOUND_TOPPAGESJOINUS
  keep?: boolean
  payload: {
    toppagesjoinus: IpaginatedToppagesjoinus
  }
}

export interface ISearchingToppagesjoinusFailedAction {
  type: ToppagesjoinusActionTypes.SEARCHING_TOPPAGESJOINUS_FAILED
}

export interface ILoadToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.LOAD_TOPPAGESJOINUS
  loadOptions: TSearchOptions
}

export interface ILoadingToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.LOADING_TOPPAGESJOINUS
}

export interface ILoadedToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.LOADED_TOPPAGESJOINUS
  payload: {
    toppagesjoinus: IpaginatedToppagesjoinus
  }
}

export interface ILoadingToppagesjoinusFailedAction {
  type: ToppagesjoinusActionTypes.LOADING_TOPPAGESJOINUS_FAILED
}

export interface IAddToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.ADD_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface IAddingToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.ADDING_TOPPAGESJOINUS
}

export interface IAddedToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.ADDED_TOPPAGESJOINUS
  payload: {
    toppagesjoinus: IpaginatedToppagesjoinus
  }
}

export interface IAddingToppagesjoinusFailedAction {
  type: ToppagesjoinusActionTypes.ADDING_TOPPAGESJOINUS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveToppagejoinusAction {
  type: ToppagesjoinusActionTypes.REMOVE_TOPPAGEJOINUS
  payload: IToppagesjoinusItem
}

export interface IRemovingToppagejoinusAction {
  type: ToppagesjoinusActionTypes.REMOVING_TOPPAGEJOINUS
}

export interface IRemovedToppagejoinusAction {
  type: ToppagesjoinusActionTypes.REMOVED_TOPPAGEJOINUS
}

export interface IRemovingToppagejoinusFailedAction {
  type: ToppagesjoinusActionTypes.REMOVING_TOPPAGEJOINUS_FAILED
}

export interface ISoftRemoveToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.SOFT_REMOVE_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface ISoftRemovingToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.SOFT_REMOVING_TOPPAGESJOINUS
}

export interface ISoftRemovedToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.SOFT_REMOVED_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface ISoftRemovingToppagesjoinusFailedAction {
  type: ToppagesjoinusActionTypes.SOFT_REMOVING_TOPPAGESJOINUS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.EDIT_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface IEditingToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.EDITING_TOPPAGESJOINUS
}

export interface IEditedToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.EDITED_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface IEditingToppagesjoinusFailedAction {
  type: ToppagesjoinusActionTypes.EDITING_TOPPAGESJOINUS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.VIEW_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface IViewingToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.VIEWING_TOPPAGESJOINUS
}

export interface IViewedToppagesjoinusAction {
  type: ToppagesjoinusActionTypes.VIEWED_TOPPAGESJOINUS
  payload: IToppagesjoinusItem
}

export interface IViewingToppagesjoinusFailedAction {
  type: ToppagesjoinusActionTypes.VIEWING_TOPPAGESJOINUS_FAILED
}

export type ToppagesjoinusAction =
  | ISearchToppagesjoinusAction
  | ISearchingToppagesjoinusAction
  | IFoundToppagesjoinusAction
  | ISearchingToppagesjoinusFailedAction
  | ILoadToppagesjoinusAction
  | ILoadingToppagesjoinusAction
  | ILoadedToppagesjoinusAction
  | ILoadingToppagesjoinusFailedAction
  | IAddToppagesjoinusAction
  | IAddingToppagesjoinusAction
  | IAddedToppagesjoinusAction
  | IAddingToppagesjoinusFailedAction
  | IRemoveToppagejoinusAction
  | IRemovingToppagejoinusAction
  | IRemovedToppagejoinusAction
  | IRemovingToppagejoinusFailedAction
  | ISoftRemoveToppagesjoinusAction
  | ISoftRemovingToppagesjoinusAction
  | ISoftRemovedToppagesjoinusAction
  | ISoftRemovingToppagesjoinusFailedAction
  | IEditToppagesjoinusAction
  | IEditingToppagesjoinusAction
  | IEditedToppagesjoinusAction
  | IEditingToppagesjoinusFailedAction
  | IViewToppagesjoinusAction
  | IViewingToppagesjoinusAction
  | IViewedToppagesjoinusAction
  | IViewingToppagesjoinusFailedAction
